import script from "./MakercrateSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MakercrateSection.vue?vue&type=script&setup=true&lang=js"

import "./MakercrateSection.vue?vue&type=style&index=0&id=6090018b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6090018b"]])

export default __exports__